import gql from "graphql-tag";

const getObjetivesById = gql`
  query Objective($objectiveId: ID!) {
    objective(id: $objectiveId) {
      id
      name
      description
      weighing
      perspective {
        id
      }
    }
  }
`;

const getObjetivesByPerspective = gql`
  query Query($args: FilterParamsInput) {
    searchObjectives(args: $args) {
      data {
        id
        name
        description
        weighing
        perspective {
          id
          name
        }
        responsibles {
          responsibleId
        }
        strategies {
          id
          name
        }
        projects {
          id
        }
      }
    }
  }
`;

export { getObjetivesById, getObjetivesByPerspective }